// Strictly typed CustomerOTPSubmitForm.tsx (fixed for reduxForm HOC)
import React, { useState } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { Field, reduxForm, InjectedFormProps } from 'redux-form'
import { FormButtons, renderers, validations } from '../../components'
import { ResendOTPButton } from './ResendOTPButton'

interface CustomerOTPFormData {
  otp: string
}

interface Props {
  getOTPHandler: () => void
  goBack: () => void
}

const CustomerOTPSubmitForm = (
  props: InjectedFormProps<CustomerOTPFormData, Props> & Props
) => {
  const [isBackButtonVisible, setBackButtonVisible] = useState<boolean>(false)
  const { handleSubmit, pristine, reset, submitting, goBack, getOTPHandler } = props

  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Col xs={12} sm={12}>
        <Field
          name="otp"
          type="password"
          component={renderers.renderField}
          label="OTP"
          validate={[validations.required]}
        />

        <ReactBootstrap.Col xs={12} sm={12} style={{ marginLeft: '-8px' }} className="pl-0">
          <ResendOTPButton
            onRequestOTP={getOTPHandler}
            onButtonStateChanged={setBackButtonVisible}
          />
        </ReactBootstrap.Col>

        <ReactBootstrap.Col xs={12} sm={6} className="text-end">
          {isBackButtonVisible && (
            <ReactBootstrap.Button
              onClick={() => goBack()}
              variant="link"
              className="float-end btn text-dark btn-sm"
            >
              Back
            </ReactBootstrap.Button>
          )}
        </ReactBootstrap.Col>

        <ReactBootstrap.Col xs={12} sm={12} className="pl-2">
          <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
        </ReactBootstrap.Col>
      </ReactBootstrap.Col>
    </form>
  )
}

export default reduxForm<CustomerOTPFormData, Props>({
  form: 'CustomerOTPSubmitForm',
})(CustomerOTPSubmitForm)
